import { render, staticRenderFns } from "./language_select.vue?vue&type=template&id=228c9f31&scoped=true"
import script from "./language_select.vue?vue&type=script&lang=js"
export * from "./language_select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228c9f31",
  null
  
)

export default component.exports